export const ModalContentEmpty = () => <div>EMPTY</div>;
